<template>
  <div class="row">
    <div class="col-lg-4 m-auto">
      <card title="Registro">
        <v-form @submit.prevent="register"
          ref="form"
          v-model="valid"
          lazy-validation
        >

        <v-col cols="12">
          <v-text-field
            v-model="name"
            :counter="100"
            :error-messages="errors.name"
            :rules="nameRules"
            label="Nombre"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="email"
            :error-messages="errors.email"
            :rules="emailRules"
            label="Correo Electrónico"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="password"
            :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
            :error-messages="errors.password"
            :rules="[rules.required, passwordConfirmationRule]"
            :type="show_password ? 'text' : 'password'"
            name="input-10-1"
            label="Contraseña"
            hint="Al menos 8 carácteres"
            counter
            @click:append="show_password = !show_password"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="password_confirmation"
            :append-icon="show_password_confirmation ? 'mdi-eye' : 'mdi-eye-off'"
            :error-messages="errors.password_confirmation"
            :rules="[rules.required, passwordConfirmationRule]"
            :type="show_password_confirmation ? 'text' : 'password'"
            name="input-10-1"
            label="Confirmación de Contraseña"
            hint="Al menos 8 carácteres"
            counter
            @click:append="show_password_confirmation = !show_password_confirmation"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <v-select
          v-model="select"
          :items="items"
          :error-messages="errors.select"
          :rules="selectRules"
          label="Tipo de Usuario"
          required
        ></v-select>
        </v-col>

        <v-btn
          :disabled="!valid"
          class="mr-4"
          @click="validate"
        >
          Registro
        </v-btn>

        </v-form>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  middleware: 'guest',
  metaInfo() {
    return { title: 'Registro' };
  },

  computed: {
    passwordConfirmationRule() {
      return this.password === this.password_confirmation
        || 'Las contraseñas deben coincidir';
    },
  },

  data: () => ({
    valid: true,
    show_password: false,
    show_password_confirmation: false,
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    select: null,
    items: [
          { value: '1', text: 'Super Administrador' },
          { value: '2', text: 'Administrador' },
          { value: '3', text: 'Dashboard' },
    ],

    nameRules: [
      (v) => !!v || 'El nombre es requerido',
    ],
    emailRules: [
      (v) => !!v || 'El correo electrónico es requerido',
      (v) => /.+@.+\..+/.test(v) || 'Debe introducir un correo electrónico válido.',
    ],
    rules: {
      required: (v) => !!v || 'La contraseña es requerida',
      format: (v) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(v) || 'La contraseña no es lo suficientemente segura',
    },
    selectRules: [
      (v) => !!v || 'El tipo de usuario es requerido.',
    ],
  }),


  methods: {
      async register() {
        // Register the user.
          /* const { data } = await window.axios.post('/api/register', {
            name: this.name,
            email: this.email,
            password: this.password,
            password_confirmation: this.password_confirmation,
            role: this.select,
          });

          // Log in the user.
          const { data: { token } } = await window.axios.post('/api/login', {
            email: this.email,
            password: this.password,
          });

          // Save the token.
          this.$store.dispatch('auth/saveToken', { token });

          // Redirect home.
          this.$router.push({ name: 'home' }); */
      },
      validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.register();
      }
    },
  },
};
</script>
